// Third Party
import { Link } from '@components/link';

// Utils
import { routes } from '@routes';
import { Props } from '.';

// UI
import { MobileSection } from './mobile-section';
import { ThreeUpDesktopSection } from './three-up-desktop-section';
import { FourUpDesktopSection } from './four-up-desktop-section';

export const PmListingsCarouselSection: React.FC<Props> = ({
  listings,
  accountSlug,
}) => {
  // listings should always contain more than 2 listings
  if (listings == undefined) return null;
  if (listings.length < 2) return null;

  return (
    <div>
      {/* large screens and up */}
      <FourUpDesktopSection listings={listings} />
      {/* small screens up to large */}
      <ThreeUpDesktopSection listings={listings} />
      {/* up to small screens */}
      <MobileSection listings={listings} />

      <div className="flex justify-center my-4 sm:mt-8">
        <div className="hidden lg:block">
          <Link
            to={routes.accounts(accountSlug || '')}
            isButton={true}
            size={'md'}
          >
            Explore Other Properties &raquo;
          </Link>
        </div>
        <div className="block lg:hidden">
          <Link
            to={routes.accounts(accountSlug || '')}
            isButton={true}
            size={'sm'}
          >
            Explore Other Properties &raquo;
          </Link>
        </div>
      </div>
    </div>
  );
};
